import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { AccountService } from '../../system/accounts/service/account.service';
import { removeOtherSessions } from '../state/auth.actions';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { TrackingType } from 'src/app/model/session-tracking/tracking-type';
import { AuthService } from '../service/auth.service';
import { take } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthActions } from '../state/action-types';

@Component({
    selector: 'app-other-sessions-active',
    templateUrl: './other-sessions-active.component.html',
    styleUrls: ['./other-sessions-active.component.scss']
})
export class OtherSessionsActiveComponent implements OnInit {
    msg: MsgModel = new MsgModel();

    isLoading: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<AppState>,
        private accountService: AccountService,
        private loginTokenService: LoginTokenService,
        private authService: AuthService,
        private helperService: HelperService,
        private dialogRef: MatDialogRef<OtherSessionsActiveComponent>
    ) {}

    ngOnInit(): void {}

    removeOtherSessions() {
        this.isLoading = true;
        const userToken = localStorage.getItem('userToken');
        if (userToken) {
            let userTokenJSON = JSON.parse(userToken);

            if (userTokenJSON.msg.OTHER_SESSIONS_ACTIVE && userTokenJSON.msg.OTHER_SESSIONS_ACTIVE >= userTokenJSON.msg.MAX_SESSIONS_ALLOWED) {
                let user = userTokenJSON.user;

                this.accountService.removeOtherSessions().subscribe((res: any) => {
                    if (res.msg) {
                        if (res.msg.SUCCESS || res.msg.OTHER_SESSIONS_ACTIVE === 0) {
                            this.store.dispatch(removeOtherSessions());
                        } else {
                            this.msg = res.msg;
                        }
                    } else {
                        this.msg.SUCCESS = false;
                        this.msg.MSG = 'Error removing other sessions. Try again.';
                    }
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        } else {
            this.isLoading = false;
        }
    }

    logout() {
        this.store.dispatch(AuthActions.logout());
        this.dialogRef.close();
    }
}
